// POSITION API
import Request from '../base'
export default {
  listProvince () {
    return Request.post('/ebermain/mainapi/dictionary/position/listProvince')
  },
  listCity (options) {
    return Request.post('/ebermain/mainapi/dictionary/position/listCity', options)
  },
  listCounty (options) {
    return Request.post('/ebermain/mainapi/dictionary/position/listCounty', options)
  },
  listTown (options) {
    return Request.post('/ebermain/mainapi/dictionary/position/listTown', options)
  },
  listVillage (options) {
    return Request.post('/ebermain/mainapi/dictionary/position/listVillage', options)
  },
  listPath (options) {
    return Request.post('/ebermain/mainapi/dictionary/position/listPath', options)
  },
  save (options) {
    return Request.post('/ebermain/mainapi/dictionary/position/save', options)
  },
  delete (options) {
    return Request.post('/ebermain/mainapi/dictionary/position/delete', options)
  },
  load (options) {
    return Request.post('/ebermain/mainapi/dictionary/position/load', options)
  },
  list (options) {
    return Request.post('/ebermain/mainapi/dictionary/position/list', options)
  },
  find (pagination, options) {
    return Request.post('/ebermain/mainapi/dictionary/position/find', Request.paginationBody(options, pagination))
  },
  path (options) {
    return Request.post('/ebermain/mainapi/dictionary/position/path', options)
  },
  analysis (options) {
    return Request.post('/ebermain/mainapi/dictionary/position/analysis', options)
  }
}
